import axios from 'axios';
import actions from '../actions/digiRegman';

export default {
	namespaced: true,
	state: {
		competitionList: [],
		cEntries: [],
		links: [],
	},
	mutations: {
		[actions.SET_COMPETITIONS]: (state, data) => {
			state.competitionList = data;
		},
		[actions.SET_ENTRIES]: (state, data) => {
			state.cEntries = data;
		},
		[actions.SET_LINK]: (state, data) => {
			state.links = data.links;
		},
		[actions.CLEAR]: (state) => {
			state.links = [];
			state.competitionList = [];
			state.cEntries = [];
		},
	},
	actions: {
		[actions.GET_DIGI_REG_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'digiregman_links');

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINK, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_COMPETITIONS]: async ({ commit, state }) => {
			try {
				const link = state.links.find(x => x.rel === 'get_competitions');

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_COMPETITIONS, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_COMPETITIONENTRIES]: async ({ commit, state }, id) => {
			try {
				const link = state.links.find(x => x.rel === 'get_entries');
				const href = link.href.replace('{competitionId}', id);

				const response = await axios.get(href);

				const { data } = response;

				commit(actions.SET_ENTRIES, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.SET_START]: async ({ state }, { id, val }) => {
			try {
				const link = state.links.find(x => x.rel === 'set_start');
				const href = link.href.replace('{entryId}', id);

				await axios.post(href, { start: val });

				// const { data } = response;
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
		[actions.ADD_COMPETITOR]: async ({ state }, id) => {
			try {
				const link = state.links.find(x => x.rel === 'add_competitor');
				const href = link.href.replace('{competitorGuid}', id);

				const response = await axios.post(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.REMOVE_COMPETITOR]: async ({ state }, id) => {
			try {
				const link = state.links.find(x => x.rel === 'remove_entry_competitor');
				const href = link.href.replace('{entryId}', id);

				const response = await axios.post(href);

				return response.status === 200;
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_DIGI_REGMAN_INFO]: async ({ state }, id) => {
			try {
				const link = state.links.find(x => x.rel === 'get_competitor');
				const href = link.href.replace('{competitorGuid}', id);

				const response = await axios.get(href);
				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.CLEAR]: async ({ commit }) => {
			commit(actions.CLEAR);
		},
	},
	getters: {
		Competitions: state => state.competitionList,
		Entries: state => state.cEntries,
		Links: state => state.links,
	},
};
